import React, { useEffect, useRef, useCallback } from "react";
import {
  Grid,
  TextField,
  Button,
  Autocomplete,
  FormControl,
  Box,
  useTheme,
  CircularProgress,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { useDispatch, useSelector } from "react-redux";
import {
  addActiveRequests,
} from "../../Redux/Reducers/uiSlice";
import { toast } from "react-toastify";
import { sendWebSocketMessage } from "../../hooks/useWebSocket";
import { selectActiveRequests } from "../../Redux/Reducers/selectors";

const HistoricalSignalsControls = ({
  strategyList,
  strategyVal,
  setStrategyVal,
  strategyValObj,
  strategySelected,
  strategies,
  isStrategist,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);

  // Check if historical signals request is active
  const activeRequests = useSelector(selectActiveRequests); 

  const isFetchingHistoricalSignals = activeRequests.includes("get_historical_signal_set");

  const handleFetchHistoricalSignals = useCallback(async () => {
    if (!strategyValObj) {
      return;
    }

    try {
      // Add active request to show loading state
      dispatch(addActiveRequests("get_historical_signal_set"));

      // Send websocket request
      const requestData = {
        action: "get_historical_signal_set",
        data: {
          strategy: strategyValObj,
          fetchPerformance: true
        }
      };

      sendWebSocketMessage(JSON.stringify(requestData));
    } catch (error) {
      console.error("Error sending websocket request:", error);
    }
  }, [strategyValObj, dispatch]);

  // Auto-fetch when strategy changes
  useEffect(() => {
    // Skip the first render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Only fetch if strategy is selected
    if (strategyValObj) {
      handleFetchHistoricalSignals();
    }
  }, [strategyValObj, handleFetchHistoricalSignals]);

  return (
    <Box>
      <Grid container spacing={3} alignItems="center">
        {/* Strategy Selection */}
        <Grid item xs={12} md={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControl fullWidth>
              <Autocomplete
                options={strategyList || []}
                value={strategyVal}
                autoSelect
                disabled={isFetchingHistoricalSignals}
                onChange={(e, newValue) => {
                  setStrategyVal(newValue);

                  const strObj = strategies?.find((i) => {
                    return i?.name === newValue;
                  });
                  if (strObj && strObj?.strategyId) {
                    strategySelected(strObj?.strategyId);
                  } else {
                    strategySelected(null);
                  }
                }}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Strategy to View"
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: isFetchingHistoricalSignals ? (
                        <CircularProgress size={20} sx={{ mr: 2 }} />
                      ) : (
                        params.InputProps.endAdornment
                      ),
                    }}
                  />
                )}
              />
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HistoricalSignalsControls;
